import { defineMessages } from 'react-intl'

export const i18nMessages = defineMessages({
    createLesson: {
        id: 'globalwords.create.lesson',
        defaultMessage: 'Create lesson',
    },
    recreateLesson: {
        id: 'globalwords.recreate.lesson',
        defaultMessage: 'Recreate Lesson',
    },

    createQuizDialogeMessage: {
        id: 'create.knowledge.ai.lesson.plan.lesson.create.quiz.question',
        defaultMessage: 'Write a question and the answer. Also add at least one incorrect answer.',
    },
    addNewQuizQuestion: {
        id: 'create.knowledge.ai.lesson.plan.lesson.add.new.quiz.question',
        defaultMessage: 'Add a new quiz question',
    },
    question: {
        id: 'globalwords.question',
        defaultMessage: 'Question',
    },
    correctAnswer: {
        id: 'globalwords.correctAnswer',
        defaultMessage: 'Correct answer',
    },
    incorrectAnswerNumber: {
        id: 'globalwords.incorrect.answer.number',
        defaultMessage: 'Incorrect answer {number}',
    },
    writeLessonPlot: {
        id: 'create.knowledge.ai.lesson.write.lesson.plot',
        defineMessage: 'Write the lesson plot',
    },
    writeLessonPlotDesc: {
        id: 'create.knowledge.ai.lesson.write.lesson.plot.desc',
        defaultMessage:
            'Write the plot that the lesson will be based on. Give as much detail as you wish on what should happen in the story.',
    },
    allImagesFail: {
        id: 'create.knowledge.ai.image.generation.fail.message',
        defaultMessage: 'Failed to generate all images.',
    },
    someImagesFail: {
        id: 'create.knowledge.ai.some.image.generation.fail.message',
        defaultMessage: 'Failed to generate some images.',
    },
    dashboardGraphsYLabelHours: {
        id: 'dashboard.graphs.ylabel.hours',
        defaultMessage: 'Hours',
    },
    dashboardGraphsYLabelSessions: {
        id: 'dashboard.graphs.ylabel.sessions',
        defaultMessage: 'Sessions',
    },
    dashboardGraphsYLabelStars: {
        id: 'dashboard.graphs.ylabel.stars',
        defaultMessage: 'Stars',
    },
    dashboardGraphsYLabelLessons: {
        id: 'dashboard.graphs.ylabel.lessons',
        defaultMessage: 'Lessons',
    },
    dashboardGraphsYLabelAnswers: {
        id: 'dashboard.graphs.ylabel.answers',
        defaultMessage: 'Answers',
    },

    adminUtilitiesTitle: {
        id: 'globalwords.admin.utilities.title',
        defaultMessage: 'Utilities',
    },
    adminUtilitiesDescription: {
        id: 'globalwords.admin.utilities.description',
        defaultMessage: 'Maintenance tools for Capeesh admins. These act on the currently selected organization.',
    },
    adminUtilitiesWritingRepairTitle: {
        id: 'globalwords.admin.utilities.writing.repair.title',
        defaultMessage: 'Recompute writing test scores',
    },
    adminUtilitiesWritingRepairDescription: {
        id: 'globalwords.admin.utilities.writing.repair.description',
        defaultMessage:
            'Finds lesson results that were stored as 100% even though the ai writing evaluation gave a lower score, and corrects them from the stored evaluation. Run the preview first. Completed and passed status is not changed.',
    },
    adminUtilitiesPreview: {
        id: 'globalwords.admin.utilities.preview',
        defaultMessage: 'Preview',
    },
    adminUtilitiesRunMigration: {
        id: 'globalwords.admin.utilities.run.migration',
        defaultMessage: 'Run migration',
    },
    adminUtilitiesNoResults: {
        id: 'globalwords.admin.utilities.no.results',
        defaultMessage: 'No affected lesson results were found for this organization.',
    },
    adminUtilitiesSummary: {
        id: 'globalwords.admin.utilities.summary',
        defaultMessage: 'Found {total} affected results, {repairable} can be corrected, {skipped} skipped.',
    },
    adminUtilitiesAppliedSummary: {
        id: 'globalwords.admin.utilities.applied.summary',
        defaultMessage: 'Corrected {applied} lesson results.',
    },
    adminUtilitiesTruncated: {
        id: 'globalwords.admin.utilities.truncated',
        defaultMessage:
            'Showing the first {shown} of {total} results. Run the migration again afterwards for the rest.',
    },
    adminUtilitiesColumnStudent: {
        id: 'globalwords.admin.utilities.column.student',
        defaultMessage: 'Student',
    },
    adminUtilitiesColumnLesson: {
        id: 'globalwords.admin.utilities.column.lesson',
        defaultMessage: 'Lesson',
    },
    adminUtilitiesColumnCompleted: {
        id: 'globalwords.admin.utilities.column.completed',
        defaultMessage: 'Completed',
    },
    adminUtilitiesColumnCurrentScore: {
        id: 'globalwords.admin.utilities.column.current.score',
        defaultMessage: 'Stored score',
    },
    adminUtilitiesColumnWritingScore: {
        id: 'globalwords.admin.utilities.column.writing.score',
        defaultMessage: 'Ai writing score',
    },
    adminUtilitiesColumnNewScore: {
        id: 'globalwords.admin.utilities.column.new.score',
        defaultMessage: 'New score',
    },
    adminUtilitiesColumnStars: {
        id: 'globalwords.admin.utilities.column.stars',
        defaultMessage: 'Stars',
    },
    adminUtilitiesColumnStatus: {
        id: 'globalwords.admin.utilities.column.status',
        defaultMessage: 'Status',
    },
    adminUtilitiesStatusReady: {
        id: 'globalwords.admin.utilities.status.ready',
        defaultMessage: 'Will be corrected',
    },
    adminUtilitiesStatusApplied: {
        id: 'globalwords.admin.utilities.status.applied',
        defaultMessage: 'Corrected',
    },
    adminUtilitiesConfirmTitle: {
        id: 'globalwords.admin.utilities.confirm.title',
        defaultMessage: 'Run the migration?',
    },
    adminUtilitiesConfirmBody: {
        id: 'globalwords.admin.utilities.confirm.body',
        defaultMessage:
            'This will overwrite the stored score and stars on {count} lesson results for {organizationName}. This cannot be undone.',
    },
    adminUtilitiesConfirm: {
        id: 'globalwords.admin.utilities.confirm',
        defaultMessage: 'Yes, run it',
    },
    adminUtilitiesCancel: {
        id: 'globalwords.admin.utilities.cancel',
        defaultMessage: 'Cancel',
    },
    adminUtilitiesLoadFailed: {
        id: 'globalwords.admin.utilities.load.failed',
        defaultMessage: 'Something went wrong. Please try again.',
    },
    adminUtilitiesNoOrganization: {
        id: 'globalwords.admin.utilities.no.organization',
        defaultMessage: 'Select an organization first.',
    },

    capeeshAccessTitle: {
        id: 'globalwords.capeesh.access.title',
        defaultMessage: 'Capeesh access',
    },
    capeeshAccessDescription: {
        id: 'globalwords.capeesh.access.description',
        defaultMessage:
            'Who at Capeesh can see data across organizations. Reporting everywhere gives a reporting role in every organization the person is not already a member of. Roles they already hold are kept as they are.',
    },
    capeeshAccessGrantLabel: {
        id: 'globalwords.capeesh.access.grant.label',
        defaultMessage: 'Capeesh email address',
    },
    capeeshAccessGrantButton: {
        id: 'globalwords.capeesh.access.grant.button',
        defaultMessage: 'Give reporting everywhere',
    },
    capeeshAccessGrantHint: {
        id: 'globalwords.capeesh.access.grant.hint',
        defaultMessage: 'Only {domains} addresses can be given access.',
    },
    capeeshAccessColumnName: {
        id: 'globalwords.capeesh.access.column.name',
        defaultMessage: 'Name',
    },
    capeeshAccessColumnEmail: {
        id: 'globalwords.capeesh.access.column.email',
        defaultMessage: 'Email',
    },
    capeeshAccessColumnAccess: {
        id: 'globalwords.capeesh.access.column.access',
        defaultMessage: 'Access',
    },
    capeeshAccessColumnOrganizations: {
        id: 'globalwords.capeesh.access.column.organizations',
        defaultMessage: 'Member of',
    },
    capeeshAccessSuperAdmin: {
        id: 'globalwords.capeesh.access.super.admin',
        defaultMessage: 'Super admin',
    },
    capeeshAccessReportingEverywhere: {
        id: 'globalwords.capeesh.access.reporting.everywhere',
        defaultMessage: 'Reporting everywhere',
    },
    capeeshAccessSuperAdminNote: {
        id: 'globalwords.capeesh.access.super.admin.note',
        defaultMessage: 'Super admin can only be changed directly in the database.',
    },
    capeeshAccessRevoke: {
        id: 'globalwords.capeesh.access.revoke',
        defaultMessage: 'Remove',
    },
    capeeshAccessNoOrganizations: {
        id: 'globalwords.capeesh.access.no.organizations',
        defaultMessage: 'No organizations',
    },
    capeeshAccessNoUsers: {
        id: 'globalwords.capeesh.access.no.users',
        defaultMessage: 'Nobody has cross organization access yet.',
    },
    capeeshAccessGranted: {
        id: 'globalwords.capeesh.access.granted',
        defaultMessage: 'Access given to {email}.',
    },
    capeeshAccessRevoked: {
        id: 'globalwords.capeesh.access.revoked',
        defaultMessage: 'Access removed.',
    },
    capeeshAccessRevokeConfirmTitle: {
        id: 'globalwords.capeesh.access.revoke.confirm.title',
        defaultMessage: 'Remove access?',
    },
    capeeshAccessRevokeConfirmBody: {
        id: 'globalwords.capeesh.access.revoke.confirm.body',
        defaultMessage:
            '{name} will no longer see statistics for organizations they are not a member of. Roles they hold in their own organizations are kept.',
    },
    capeeshAccessConfirm: {
        id: 'globalwords.capeesh.access.confirm',
        defaultMessage: 'Remove access',
    },
    capeeshAccessCancel: {
        id: 'globalwords.capeesh.access.cancel',
        defaultMessage: 'Cancel',
    },
    capeeshAccessLoadFailed: {
        id: 'globalwords.capeesh.access.load.failed',
        defaultMessage: 'Something went wrong. Please try again.',
    },

    // Administrators everywhere - super admin page listing every administrator in every organization
    administratorAccessTitle: {
        id: 'globalwords.administratoraccess.title',
        defaultMessage: 'Administrators',
    },
    administratorAccessDescription: {
        id: 'globalwords.administratoraccess.description',
        defaultMessage:
            'Everyone who administers an organization, and what they administer. One row per organization, so someone who administers several appears several times.',
    },
    administratorAccessSearchLabel: {
        id: 'globalwords.administratoraccess.search.label',
        defaultMessage: 'Search by email',
    },
    administratorAccessSearchHint: {
        id: 'globalwords.administratoraccess.search.hint',
        defaultMessage: 'Matches email addresses only. Sort by organization to see everyone in one place.',
    },
    administratorAccessColumnUser: {
        id: 'globalwords.administratoraccess.column.user',
        defaultMessage: 'User',
    },
    administratorAccessColumnEmail: {
        id: 'globalwords.administratoraccess.column.email',
        defaultMessage: 'Email',
    },
    administratorAccessColumnOrganization: {
        id: 'globalwords.administratoraccess.column.organization',
        defaultMessage: 'Organization',
    },
    administratorAccessColumnAccessType: {
        id: 'globalwords.administratoraccess.column.accesstype',
        defaultMessage: 'Access type',
    },
    administratorAccessSummary: {
        id: 'globalwords.administratoraccess.summary',
        defaultMessage: '{administrators} administrators across {organizations} organizations',
    },
    administratorAccessShowingCount: {
        id: 'globalwords.administratoraccess.showingcount',
        defaultMessage: 'Showing {shown} of {total} rows',
    },
    administratorAccessNoEmailNote: {
        id: 'globalwords.administratoraccess.noemail.note',
        defaultMessage:
            '{count} rows have no email address and can never match a search. Clear the search to see them.',
    },
    administratorAccessNoRows: {
        id: 'globalwords.administratoraccess.norows',
        defaultMessage: 'No administrators match that email.',
    },
    administratorAccessNoEmailPlaceholder: {
        id: 'globalwords.administratoraccess.noemail.placeholder',
        defaultMessage: 'No email address',
    },
    administratorAccessRevokeOrganization: {
        id: 'globalwords.administratoraccess.revoke.organization',
        defaultMessage: 'Revoke here',
    },
    administratorAccessRevokeAll: {
        id: 'globalwords.administratoraccess.revoke.all',
        defaultMessage: 'Revoke everywhere',
    },
    administratorAccessRevokeOrganizationTitle: {
        id: 'globalwords.administratoraccess.revoke.organization.title',
        defaultMessage: 'Revoke access to this organization',
    },
    administratorAccessRevokeOrganizationBody: {
        id: 'globalwords.administratoraccess.revoke.organization.body',
        defaultMessage:
            '{name} will lose their {role} access to {organization}, along with their classrooms there. Access to other organizations is kept.',
    },
    administratorAccessRevokeAllTitle: {
        id: 'globalwords.administratoraccess.revoke.all.title',
        defaultMessage: 'Revoke all access',
    },
    administratorAccessRevokeAllBody: {
        id: 'globalwords.administratoraccess.revoke.all.body',
        defaultMessage:
            '{name} will lose administrator access to every organization, and their reporting access to all organizations if they have it. Super admin is not affected.',
    },
    administratorAccessLastAdminWarning: {
        id: 'globalwords.administratoraccess.lastadmin.warning',
        defaultMessage:
            'This leaves {organizations} without a single Capeesh Admin. Nobody will be able to administer it.',
    },
    administratorAccessCannotRevokeSelf: {
        id: 'globalwords.administratoraccess.cannotrevokeself',
        defaultMessage: 'You cannot revoke your own access.',
    },
    administratorAccessRevoked: {
        id: 'globalwords.administratoraccess.revoked',
        defaultMessage: 'Access revoked.',
    },
    administratorAccessRevokedLeftWithout: {
        id: 'globalwords.administratoraccess.revoked.leftwithout',
        defaultMessage: 'Access revoked. {organizations} now has no Capeesh Admin.',
    },
    administratorAccessSuperAdminBadge: {
        id: 'globalwords.administratoraccess.badge.superadmin',
        defaultMessage: 'Super admin',
    },
    administratorAccessAllOrgReportingBadge: {
        id: 'globalwords.administratoraccess.badge.allorgreporting',
        defaultMessage: 'Reporting everywhere',
    },

    exportClassroomsToInclude: {
        id: 'globalwords.export.classrooms.to.include',
        defaultMessage: 'Classrooms to include',
    },
    exportClassroomsToIncludeDescription: {
        id: 'globalwords.export.classrooms.to.include.description',
        defaultMessage: 'All classrooms are included. Untick a classroom to leave it out of the report.',
    },
    exportNoClassroomsAvailable: {
        id: 'globalwords.export.no.classrooms.available',
        defaultMessage: 'No classrooms available.',
    },
    exportColumns: {
        id: 'globalwords.export.columns',
        defaultMessage: 'Columns',
    },
    exportColumnPassed: {
        id: 'globalwords.export.column.passed',
        defaultMessage: 'Passed',
    },
    exportColumnClassroom: {
        id: 'globalwords.export.column.classroom',
        defaultMessage: 'Classroom',
    },

    pdfColumnsTitle: {
        id: 'globalwords.pdf.columns.title',
        defaultMessage: 'Choose columns',
    },
    pdfColumnsDescription: {
        id: 'globalwords.pdf.columns.description',
        defaultMessage: 'Pick which columns to show for each lesson in the report.',
    },
    pdfColumnStatus: {
        id: 'globalwords.pdf.column.status',
        defaultMessage: 'Status',
    },
    pdfColumnScore: {
        id: 'globalwords.pdf.column.score',
        defaultMessage: 'Points',
    },
    pdfColumnTime: {
        id: 'globalwords.pdf.column.time',
        defaultMessage: 'Time',
    },
    pdfColumnDate: {
        id: 'globalwords.pdf.column.date',
        defaultMessage: 'Date',
    },
    pdfColumnsCancel: {
        id: 'globalwords.pdf.columns.cancel',
        defaultMessage: 'Cancel',
    },
    pdfColumnsDownload: {
        id: 'globalwords.pdf.columns.download',
        defaultMessage: 'Download PDF',
    },

    // Course statistics.
    //
    // Naming here follows the dashboard, which no longer maps 1-1 onto the backend model:
    //   backend CourseGroup -> "course" on screen
    //   backend Topic       -> "topic" on screen
    // API field names (courseGroupId, topicId, topicName ...) deliberately keep the backend
    // spelling, so only the visible strings translate between the two vocabularies.
    courseStatisticsTabOverview: {
        id: 'globalwords.coursestatistics.tab.overview',
        defaultMessage: 'Overview',
    },
    courseStatisticsTabCourses: {
        id: 'globalwords.coursestatistics.tab.courses',
        defaultMessage: 'Courses',
    },
    courseStatisticsTitle: {
        id: 'globalwords.coursestatistics.title',
        defaultMessage: 'Course statistics',
    },
    courseStatisticsAllCourses: {
        id: 'globalwords.coursestatistics.allcourses',
        defaultMessage: 'All courses',
    },
    courseStatisticsAllTopics: {
        id: 'globalwords.coursestatistics.alltopics',
        defaultMessage: 'All topics',
    },
    courseStatisticsBackToCourses: {
        id: 'globalwords.coursestatistics.backtocourses',
        defaultMessage: 'Back to course statistics',
    },
    courseStatisticsExport: {
        id: 'globalwords.coursestatistics.export',
        defaultMessage: 'Export to Excel',
    },
    courseStatisticsPeriod: {
        id: 'globalwords.coursestatistics.period',
        defaultMessage: 'Period',
    },
    courseStatisticsDateRangeAll: {
        id: 'globalwords.coursestatistics.daterange.all',
        defaultMessage: 'All time',
    },
    courseStatisticsDateRangeLast30: {
        id: 'globalwords.coursestatistics.daterange.last30',
        defaultMessage: 'Last 30 days',
    },
    courseStatisticsDateRangeLast90: {
        id: 'globalwords.coursestatistics.daterange.last90',
        defaultMessage: 'Last 90 days',
    },
    courseStatisticsDateRangeLastYear: {
        id: 'globalwords.coursestatistics.daterange.lastyear',
        defaultMessage: 'Last 12 months',
    },
    courseStatisticsDateRangeCustom: {
        id: 'globalwords.coursestatistics.daterange.custom',
        defaultMessage: 'Custom dates',
    },
    courseStatisticsDateFrom: {
        id: 'globalwords.coursestatistics.date.from',
        defaultMessage: 'From',
    },
    courseStatisticsDateTo: {
        id: 'globalwords.coursestatistics.date.to',
        defaultMessage: 'To',
    },
    courseStatisticsDateRangeInvalid: {
        id: 'globalwords.coursestatistics.daterange.invalid',
        defaultMessage: 'The from date is after the to date.',
    },
    courseStatisticsNoData: {
        id: 'globalwords.coursestatistics.nodata',
        defaultMessage: 'No topic activity to show for this selection yet.',
    },
    courseStatisticsCompletionNoteOnDateRange: {
        id: 'globalwords.coursestatistics.completionnote',
        defaultMessage:
            'Usage and scores follow the selected period. Completion counts all time, so a topic finished earlier still counts as finished.',
    },

    // course statistics - headline strip
    courseStatisticsTopicsInUse: {
        id: 'globalwords.coursestatistics.topicsinuse',
        defaultMessage: 'Topics in use',
    },
    courseStatisticsActiveUsers: {
        id: 'globalwords.coursestatistics.activeusers',
        defaultMessage: 'Active users',
    },
    courseStatisticsHoursSpent: {
        id: 'globalwords.coursestatistics.hoursspent',
        defaultMessage: 'Hours spent',
    },

    // course statistics - topic table
    courseStatisticsColumnTopic: {
        id: 'globalwords.coursestatistics.column.topic',
        defaultMessage: 'Topic',
    },
    courseStatisticsColumnCourse: {
        id: 'globalwords.coursestatistics.column.course',
        defaultMessage: 'Course',
    },
    courseStatisticsAssignedUsers: {
        id: 'globalwords.coursestatistics.assignedusers',
        defaultMessage: 'Assigned',
    },
    courseStatisticsPercentStarted: {
        id: 'globalwords.coursestatistics.percentstarted',
        defaultMessage: 'Started',
    },
    courseStatisticsPercentFinished: {
        id: 'globalwords.coursestatistics.percentfinished',
        defaultMessage: 'Finished',
    },
    courseStatisticsLessonsPassed: {
        id: 'globalwords.coursestatistics.lessonspassed',
        defaultMessage: 'Lessons passed',
    },
    courseStatisticsAverageScore: {
        id: 'globalwords.coursestatistics.averagescore',
        defaultMessage: 'Avg score',
    },
    courseStatisticsAverageStars: {
        id: 'globalwords.coursestatistics.averagestars',
        defaultMessage: 'Avg stars',
    },
    courseStatisticsSortBy: {
        id: 'globalwords.coursestatistics.sortby',
        defaultMessage: 'Sort by',
    },
    courseStatisticsSortMostUsed: {
        id: 'globalwords.coursestatistics.sort.mostused',
        defaultMessage: 'Most used',
    },
    courseStatisticsSortLowestAdoption: {
        id: 'globalwords.coursestatistics.sort.lowestadoption',
        defaultMessage: 'Lowest adoption',
    },
    courseStatisticsSortLowestScore: {
        id: 'globalwords.coursestatistics.sort.lowestscore',
        defaultMessage: 'Lowest average score',
    },

    // course statistics - detail panel
    courseStatisticsTrendTitle: {
        id: 'globalwords.coursestatistics.trend.title',
        defaultMessage: 'Activity over time',
    },
    courseStatisticsScoreDistribution: {
        id: 'globalwords.coursestatistics.scoredistribution',
        defaultMessage: 'Score distribution',
    },
    courseStatisticsFindUsersInTopic: {
        id: 'globalwords.coursestatistics.findusersintopic',
        defaultMessage: 'Find users in this topic',
    },
    courseStatisticsUsersWithScore: {
        id: 'globalwords.coursestatistics.userswithscore',
        defaultMessage: '{count} users with a score',
    },

    // course statistics - filter panel
    courseStatisticsFilterTitle: {
        id: 'globalwords.coursestatistics.filter.title',
        defaultMessage: 'Find users',
    },
    courseStatisticsFilterIntro: {
        id: 'globalwords.coursestatistics.filter.intro',
        defaultMessage: 'Pick a saved question or build your own to list the users behind these numbers.',
    },
    courseStatisticsFilterPreset: {
        id: 'globalwords.coursestatistics.filter.preset',
        defaultMessage: 'Saved question',
    },
    courseStatisticsFilterCustom: {
        id: 'globalwords.coursestatistics.filter.custom',
        defaultMessage: 'Custom rules',
    },
    courseStatisticsFilterAddRule: {
        id: 'globalwords.coursestatistics.filter.addrule',
        defaultMessage: 'Add rule',
    },
    courseStatisticsFilterMatchAll: {
        id: 'globalwords.coursestatistics.filter.matchall',
        defaultMessage: 'Match all rules',
    },
    courseStatisticsFilterMatchAny: {
        id: 'globalwords.coursestatistics.filter.matchany',
        defaultMessage: 'Match any rule',
    },
    courseStatisticsFilterApply: {
        id: 'globalwords.coursestatistics.filter.apply',
        defaultMessage: 'Apply',
    },
    courseStatisticsFilterMatchCount: {
        id: 'globalwords.coursestatistics.filter.matchcount',
        defaultMessage: '{users} of {evaluated} users match',
    },
    courseStatisticsFilterNoMatches: {
        id: 'globalwords.coursestatistics.filter.nomatches',
        defaultMessage: 'No users match these rules.',
    },
    courseStatisticsFilterNeedsTopic: {
        id: 'globalwords.coursestatistics.filter.needstopic',
        defaultMessage: 'Pick a topic above. This saved question asks about scores in one topic.',
    },
    courseStatisticsFindUsersNotAvailable: {
        id: 'globalwords.coursestatistics.findusers.notavailable',
        defaultMessage:
            'This organization does not show statistics for individual learners. Course statistics are still available.',
    },
    courseStatisticsFilterIdentitiesHidden: {
        id: 'globalwords.coursestatistics.filter.identitieshidden',
        defaultMessage: 'This organization hides learner names, so only dashboard nicknames are shown.',
    },
    courseStatisticsFilterScopedToTopic: {
        id: 'globalwords.coursestatistics.filter.scopedtotopic',
        defaultMessage: 'Scoped to {topic}',
    },
    courseStatisticsFilterClearTopicScope: {
        id: 'globalwords.coursestatistics.filter.cleartopicscope',
        defaultMessage: 'Clear topic',
    },

    // course statistics - filter builder rule labels
    courseStatisticsFilterRuleScope: {
        id: 'globalwords.coursestatistics.filter.rule.scope',
        defaultMessage: 'Applies to',
    },
    courseStatisticsFilterRuleMetric: {
        id: 'globalwords.coursestatistics.filter.rule.metric',
        defaultMessage: 'Measure',
    },
    courseStatisticsFilterRuleCondition: {
        id: 'globalwords.coursestatistics.filter.rule.condition',
        defaultMessage: 'Condition',
    },

    // course statistics - filter scopes, metrics and operators
    courseStatisticsScopeTopic: {
        id: 'globalwords.coursestatistics.filter.scope.topic',
        defaultMessage: 'Topic',
    },
    courseStatisticsScopeCourse: {
        id: 'globalwords.coursestatistics.filter.scope.course',
        defaultMessage: 'Course',
    },
    courseStatisticsMetricAverageScore: {
        id: 'globalwords.coursestatistics.filter.metric.averagescore',
        defaultMessage: 'Average score',
    },
    courseStatisticsMetricMinScore: {
        id: 'globalwords.coursestatistics.filter.metric.minscore',
        defaultMessage: 'Lowest lesson score',
    },
    courseStatisticsMetricMaxScore: {
        id: 'globalwords.coursestatistics.filter.metric.maxscore',
        defaultMessage: 'Highest lesson score',
    },
    courseStatisticsMetricAverageStars: {
        id: 'globalwords.coursestatistics.filter.metric.averagestars',
        defaultMessage: 'Average stars',
    },
    courseStatisticsMetricLessonsPassedCount: {
        id: 'globalwords.coursestatistics.filter.metric.lessonspassedcount',
        defaultMessage: 'Lessons passed',
    },
    courseStatisticsMetricLessonsPassedFraction: {
        id: 'globalwords.coursestatistics.filter.metric.lessonspassedfraction',
        defaultMessage: 'Share of lessons passed',
    },
    courseStatisticsMetricLessonsPlayedCount: {
        id: 'globalwords.coursestatistics.filter.metric.lessonsplayedcount',
        defaultMessage: 'Lessons played',
    },
    courseStatisticsMetricIsFinished: {
        id: 'globalwords.coursestatistics.filter.metric.isfinished',
        defaultMessage: 'Finished it',
    },
    courseStatisticsMetricAllLessonsPassed: {
        id: 'globalwords.coursestatistics.filter.metric.alllessonspassed',
        defaultMessage: 'Passed every lesson',
    },
    courseStatisticsMetricCompletionFraction: {
        id: 'globalwords.coursestatistics.filter.metric.completionfraction',
        defaultMessage: 'Progress through it',
    },
    courseStatisticsMetricHasStarted: {
        id: 'globalwords.coursestatistics.filter.metric.hasstarted',
        defaultMessage: 'Started it',
    },
    courseStatisticsMetricTimeSpentMinutes: {
        id: 'globalwords.coursestatistics.filter.metric.timespentminutes',
        defaultMessage: 'Minutes spent',
    },
    courseStatisticsMetricDaysSinceLastActivity: {
        id: 'globalwords.coursestatistics.filter.metric.dayssincelastactivity',
        defaultMessage: 'Days since last activity',
    },
    courseStatisticsOperatorLessThan: {
        id: 'globalwords.coursestatistics.filter.operator.lessthan',
        defaultMessage: 'is less than',
    },
    courseStatisticsOperatorLessThanOrEqual: {
        id: 'globalwords.coursestatistics.filter.operator.lessthanorequal',
        defaultMessage: 'is at most',
    },
    courseStatisticsOperatorGreaterThan: {
        id: 'globalwords.coursestatistics.filter.operator.greaterthan',
        defaultMessage: 'is more than',
    },
    courseStatisticsOperatorGreaterThanOrEqual: {
        id: 'globalwords.coursestatistics.filter.operator.greaterthanorequal',
        defaultMessage: 'is at least',
    },
    courseStatisticsOperatorEqual: {
        id: 'globalwords.coursestatistics.filter.operator.equal',
        defaultMessage: 'is',
    },
    courseStatisticsOperatorNotEqual: {
        id: 'globalwords.coursestatistics.filter.operator.notequal',
        defaultMessage: 'is not',
    },
    courseStatisticsOperatorBetween: {
        id: 'globalwords.coursestatistics.filter.operator.between',
        defaultMessage: 'is between',
    },
    courseStatisticsOperatorIsTrue: {
        id: 'globalwords.coursestatistics.filter.operator.istrue',
        defaultMessage: 'yes',
    },
    courseStatisticsOperatorIsFalse: {
        id: 'globalwords.coursestatistics.filter.operator.isfalse',
        defaultMessage: 'no',
    },

    // Course statistics preset labels, keyed from the backend preset metadata.
    // The message ids mirror the backend enum names (StrugglingInCourse ...) and stay as they are,
    // because CourseStatFilterPresetLogic emits those exact keys. Only the visible text follows the
    // dashboard vocabulary, where a backend Topic is a "topic" and a backend CourseGroup is a "course".
    courseStatisticsPresetLowScoreButCompleted: {
        id: 'globalwords.coursestatistics.filter.preset.lowscorebutcompleted',
        defaultMessage: 'Completed but scoring low',
    },
    courseStatisticsPresetLowScoreButCompletedDescription: {
        id: 'globalwords.coursestatistics.filter.preset.lowscorebutcompleted.description',
        defaultMessage: 'Learners who finished the topic but averaged below the score you set.',
    },
    courseStatisticsPresetNeverStarted: {
        id: 'globalwords.coursestatistics.filter.preset.neverstarted',
        defaultMessage: 'Never started',
    },
    courseStatisticsPresetNeverStartedDescription: {
        id: 'globalwords.coursestatistics.filter.preset.neverstarted.description',
        defaultMessage: 'Learners the course is assigned to who have not opened the topic.',
    },
    courseStatisticsPresetStartedButStalled: {
        id: 'globalwords.coursestatistics.filter.preset.startedbutstalled',
        defaultMessage: 'Started but stalled',
    },
    courseStatisticsPresetStartedButStalledDescription: {
        id: 'globalwords.coursestatistics.filter.preset.startedbutstalled.description',
        defaultMessage: 'Learners part way through a topic with no recent activity.',
    },
    courseStatisticsPresetCompletedEverything: {
        id: 'globalwords.coursestatistics.filter.preset.completedeverything',
        defaultMessage: 'Completed everything',
    },
    courseStatisticsPresetCompletedEverythingDescription: {
        id: 'globalwords.coursestatistics.filter.preset.completedeverything.description',
        defaultMessage: 'Learners who have finished every topic in the course.',
    },
    courseStatisticsPresetStrugglingInCourse: {
        id: 'globalwords.coursestatistics.filter.preset.strugglingincourse',
        defaultMessage: 'Struggling in this topic',
    },
    courseStatisticsPresetStrugglingInCourseDescription: {
        id: 'globalwords.coursestatistics.filter.preset.strugglingincourse.description',
        defaultMessage: 'Learners who have started the topic and are averaging below the score you set.',
    },
    courseStatisticsPresetHighPerformers: {
        id: 'globalwords.coursestatistics.filter.preset.highperformers',
        defaultMessage: 'High performers',
    },
    courseStatisticsPresetHighPerformersDescription: {
        id: 'globalwords.coursestatistics.filter.preset.highperformers.description',
        defaultMessage: 'Learners averaging at or above the score you set.',
    },
    courseStatisticsParameterScoreThreshold: {
        id: 'globalwords.coursestatistics.filter.parameter.scorethreshold',
        defaultMessage: 'Score threshold',
    },
    courseStatisticsParameterDaysInactive: {
        id: 'globalwords.coursestatistics.filter.parameter.daysinactive',
        defaultMessage: 'Days without activity',
    },

    // course statistics - result table
    courseStatisticsResultColumnUser: {
        id: 'globalwords.coursestatistics.result.column.user',
        defaultMessage: 'User',
    },
    courseStatisticsResultColumnClassroom: {
        id: 'globalwords.coursestatistics.result.column.classroom',
        defaultMessage: 'Classroom',
    },
    courseStatisticsResultColumnProgress: {
        id: 'globalwords.coursestatistics.result.column.progress',
        defaultMessage: 'Progress',
    },
    courseStatisticsResultColumnLastActivity: {
        id: 'globalwords.coursestatistics.result.column.lastactivity',
        defaultMessage: 'Last activity',
    },
    courseStatisticsViewCourseStatistics: {
        id: 'globalwords.coursestatistics.viewcoursestatistics',
        defaultMessage: 'View course statistics',
    },
})

// Backend preset and parameter metadata carries i18n keys rather than text, so the dashboard stays
// translatable. This maps those keys onto the messages defined above.
export const i18nMessagesByKey = Object.values(i18nMessages).reduce((accumulator, message) => {
    accumulator[message.id] = message
    return accumulator
}, {})

export default { i18nMessages }
